import axios from "@/libs/api.request";

export const getList = params => {
  return axios.request({
    url: "/common/faq/index",
    method: "get",
    params
  });
};

export const save = data => {
  return axios.request({
    url: "/common/faq/save",
    method: "post",
    data
  });
};

export const del = id => {
  return axios.request({
    url: "/common/faq/delete/"+id,
    method: "post",
  });
};